import React from 'react';
import { FormattedMessage } from 'react-intl';
import { pathOr } from 'ramda';

import { Emoji } from '../../components';
import SectionAvatar from './SectionAvatar';
import css from './ListingPage.css';

const SectionHeading = props => {
  const {
    priceTitle,
    formattedPrice,
    minCapacity,
    maxCapacity,
    user,
    params,
    listing,
  } = props;
  const unitTranslationKey = 'ListingPage.perUnit';
  const capacityText = maxCapacity ? (
    <FormattedMessage id="ListingPage.capacityText" values={{ min: minCapacity, max: maxCapacity }} />
  ) : (
    <FormattedMessage id="ListingPage.capacityTextWithoutMax" values={{ min: minCapacity }} />
  );
  const city = pathOr(null, ['attributes', 'publicData', 'location', 'city'], listing);
  const cityText = <FormattedMessage id="ListingPage.cityText" values={{ city: city }} />

  return (
    <div className={css.sectionHeading}>
      <div className={css.listingInfosContainer}>
        {city ? (
          <span className={css.city}>{cityText}</span>
        ) : null}
        <div className={css.priceContainer}>
          <div className={css.priceValue} title={priceTitle}>
            {formattedPrice}
          </div>
          <div className={css.perUnit}>
            <FormattedMessage id={unitTranslationKey} />
          </div>
        </div>
        <div className={css.capacityContainer}>
          <Emoji className={css.emoji} symbol={0x1F46A} />
          <div className={css.capacityText}>
            {capacityText}
          </div>
        </div>
      </div>
      <SectionAvatar params={params} user={user} />
    </div>
  );
};

export default SectionHeading;



// WEBPACK FOOTER //
// ./src/containers/ListingPage/SectionHeading.js